module.exports = __webpack_public_path__ + "static/media/IKEA Effect - semyon-borisov-D9rw_J7d68k-unsplash.d419c565.jpg";